import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceQuranMemorization from '../../components/ServiceQuranMemorization'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'


const ServiceQuranMemorizationPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'}/>
            <ServiceQuranMemorization/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServiceQuranMemorizationPage;
